package net.frozenbit.games.soundgame.viewmodels.presentation

class PlayerTagData(
    val name: String,
    val avatarIndex: Int,
    val isOffline: Boolean,
)